import { LegalLayout, LegalSection, LegalBlocks } from "@/pages/LegalLayout";
import Seo from "@/components/Seo";
import { useLanguage } from "@/i18n/LanguageContext";
import { LEGAL } from "@/i18n/legal";

const CookiePolicy = () => {
  const { lang } = useLanguage();
  const d = LEGAL.cookie[lang] || LEGAL.cookie.it;
  return (
    <LegalLayout title={d.title} updated={d.updated} back={d.back} updatedLabel={d.updatedLabel}>
      <Seo title={`${d.title} | XS Consulting`} description={d.metaDesc} />
      {d.sections.map((s) => (
        <LegalSection key={s.title} title={s.title}>
          <LegalBlocks blocks={s.blocks} />
        </LegalSection>
      ))}
    </LegalLayout>
  );
};

export default CookiePolicy;
